/*
  Функция отправляет на сервер запрос на выход, и возвращает Promise с результатом: ok - успешное завершение

*/

export default async function logoutUser(){
  return fetch('/api/users/logout', {
    method: 'POST',
    headers: {
      'Content-Type' : 'application/json',
      'X-Requested-With' : 'XMLHttpRequest',
    }
  }).then(
    data => {
      if (data.ok) {
        return data.text().then(text => {return {ok : (text === "ok"), error: ""}})
      } else return data.json().then(e => {return {ok: false, error: e.error}})
    }
  );
}